<template >
        <v-card class="padding elevation-0" flat>
            <h1 class="fonte">TORPEDO VOZ</h1>
            <p class="black--text">Agora ficou simples enviar torpedos a seus clientes</p>
            <v-divider class="mt-3 mb-3"></v-divider><input id="import" type="file" v-show="false" @change="processFile" accept="audio/*" />
            <v-btn round dark class="white--text" color="fundo" v-if="!fileImported" @click="carregaaudio" style="margin-bottom:60px;">Carregar Áudio
                <v-icon right="right" dark="dark">cloud_upload</v-icon>
            </v-btn>
            <v-layout justify-space-between="justify-space-between" row="row" wrap="wrap">
                <v-flex v-if="fileImported">
                    <p><strong>Nome: &nbsp;</strong>{{ torpedo.arquivoaudio.name }}</p>
                    <p><strong>Última Modificação: &nbsp;</strong>{{ getModified }}</p>
                    <p><strong>Tamanho: &nbsp;</strong>{{ ((torpedo.arquivoaudio.size / 1024) / 1024).toString().substr(0,7) + " MB" }}</p>
                </v-flex>
            </v-layout>
            <v-flex md12="md12">
                <v-text-field v-model="torpedo.campanha" color="blue-grey" box="box" label="Campanha" placeholder="Campanha" required="required"></v-text-field>
            </v-flex>
            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark round class="white--text" color="error" @click="fileImported=false,torpedo.arquivoaudio=null,torpedo.campanha=null">Cancelar</v-btn>
                <v-btn dark round class="white--text" color="blue-grey" :disabled="!fileImported">Enviar</v-btn>
            </v-card-actions>
        </v-card>
</template>


<script>
  import moment from 'moment'
  export default {
    data(){
      return {
        fileImported:false,
        torpedo:{
          arquivoaudio:'',
          campanha:''
        }
      }
    },
    methods:{
      carregaaudio()
      {
        document.getElementById("import").click()
      },
      processFile(e)
      {

        this.torpedo.arquivoaudio = e.currentTarget.files[0]
        this.fileImported=true
      }
    },
    computed:{
      getModified()
      {
        moment.locale('pt-br')
        return moment( this.torpedo.arquivoaudio.lastModified ).format('LL')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/Torpedovoz.vue